/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Souhrn`
};

const da_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Oversigt`
};

const de_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Zusammenfassung`
};

const en_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Summary`
};

const es_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Resumen`
};

const fr_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Résumé`
};

const hu_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Összefoglalás`
};

const it_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Riepilogo`
};

const nl_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Samenvatting`
};

const pl_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Podsumowanie`
};

const pt_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Resumo`
};

const sv_summary = /** @type {(inputs: {}) => string} */ () => {
	return `Sammanfattning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const summary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary", locale)
	if (locale === "cs") return cs_summary(inputs)
	if (locale === "da") return da_summary(inputs)
	if (locale === "de") return de_summary(inputs)
	if (locale === "en") return en_summary(inputs)
	if (locale === "es") return es_summary(inputs)
	if (locale === "fr") return fr_summary(inputs)
	if (locale === "hu") return hu_summary(inputs)
	if (locale === "it") return it_summary(inputs)
	if (locale === "nl") return nl_summary(inputs)
	if (locale === "pl") return pl_summary(inputs)
	if (locale === "pt") return pt_summary(inputs)
	return sv_summary(inputs)
};